/**
 * LogoutConfirmModal — logout confirmation dialog.
 * Uses ReactDOM.createPortal for reliable centering on all platforms
 * including Android WebViews where react-modal positioning can drift.
 */
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { HiOutlineLogout } from "react-icons/hi";
import "./LogoutConfirmModal.scss";

interface LogoutConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  theme: "light" | "dark";
}

const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  theme,
}) => {
  // Lock body scroll while open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={`lm-overlay ${theme}`}
      onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}
    >
      <div className={`lm-card ${theme}`}>
        {/* Coloured header banner */}
        <div className="lm-header">
          <div className="lm-header__bg" />
          <div className="lm-icon-wrap">
            <div className="lm-icon">
              <HiOutlineLogout size={26} />
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="lm-body">
          <h3 className="lm-title">Logout</h3>
          <div className="lm-divider" />
          <p className="lm-desc">Are you sure you want to logout?</p>
        </div>

        {/* Footer */}
        <div className="lm-footer">
          <button className="lm-btn lm-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="lm-btn lm-btn--confirm" onClick={onConfirm}>
            Yes, Logout
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutConfirmModal;
